
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ProgramsPage = lazy(() => import('../pages/programs/page'));
const SupportPage = lazy(() => import('../pages/support/page'));
const ApplyPage = lazy(() => import('../pages/apply/page'));
const ExperiencePage = lazy(() => import('../pages/experience/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/programs',
    element: <ProgramsPage />
  },
  {
    path: '/support',
    element: <SupportPage />
  },
  {
    path: '/apply',
    element: <ApplyPage />
  },
  {
    path: '/experience',
    element: <ExperiencePage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
